export default (state={}, action) =>{
    switch(action.type)
    {
        case 'SET_STATE_COLLAPSE_MENU_PEST1':           
             return action.payload;
        default: return state;
    }
}